import './LoggedIn.css';
import React from 'react';

function LoggedIn({ twitterUser, name, levelID }) { 
    const levelClass = `level-${levelID}`;
    // Condition 1: Twitter user
    if (twitterUser && twitterUser.screen_name) {
        return (
            <div className="loggedInUser twitter">
                <img className="twitter-logo" src="/mfersbeheaded/images/twitter.png" alt="Twitter: " />
                {twitterUser.screen_name}
            </div>
        );        
    } 
    // Condition 2: Name is present
    else if (name) {
        return (
            <div className={`loggedInUser ${levelClass}`}>
                player: {name}
            </div>
        );
    } 
    // Condition 3: Neither Twitter name nor name is present
    else {
        return (
            <div className="loggedInUser not-logged-in">
                not logged in
            </div>
        );
    }
}

export default LoggedIn;
